export default __webpack_public_path__ + "images/febc239923ed2c21cdc4a7e0c1224cb0-music_desktop-2.webp";